import React, { useState } from 'react';
import { Row, Tabs, Tab } from 'react-bootstrap';
import { translate } from 'components/translation/translation';
import CheckpointsList from './checklists/CheckpointsList';
import SetChecklist from './checklists/SetChecklist';

const ChecklistsList = () => {
	const [activeKey, setActiveKey] = useState('checkpoints');

	const entities = [
		{ name: 'tenders', label: translate('common.checkpointslist.tenders', 'Procedura') },
		{ name: 'frameworkcontracts', label: translate('common.checkpointslist.frameworkcontracts', 'Contratto aperto') },
		{ name: 'contracts', label: translate('common.checkpointslist.contracts', 'Incarico/attingimento') },
		{ name: 'invoices', label: translate('common.checkpointslist.invoices', 'Fattura') },
		{ name: 'invoicepayments', label: translate('common.checkpointslist.invoicepayments', 'Pagamento') },
		{ name: 'timesheets', label: translate('common.checkpointslist.timesheets', 'Personale/Timesheet') }
	];

	return (
		<>
			<div className="simple-box scenaritab">
				<Row>
					<Tabs className="mb-4" activeKey={activeKey} onSelect={(k) => setActiveKey(k)} variant="pills">
						<Tab eventKey="checkpoints" title={translate('common.checkpoints', 'Punti di controllo')}>
							<CheckpointsList parentActiveKey={activeKey} entities={entities} />
						</Tab>
						<Tab eventKey="setchecklist" title={translate('common.setchecklist', 'Set domande')}>
							<SetChecklist parentActiveKey={activeKey} optionsLegacyType={entities} />
						</Tab>
					</Tabs>
				</Row>
			</div>
		</>
	);
};
export default ChecklistsList;
